import { format } from 'date-fns';

export function formatExceptions(conflicts: number): string {
  return conflicts > 1000 ? '1k+' : conflicts.toString();
}

export function generateImportLabel(prefix: string): string {
  return `${prefix} ${format(new Date(), 'MM/dd/yyyy HH:mm:ss')}`;
}
